import React from 'react';
import { ShirtIcon, ExternalLink } from 'lucide-react';
import Footer from '../components/Footer';

const Students = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16">
          <span className="text-[#7d5800] font-bold text-sm uppercase tracking-wider">Student Information</span>
          <h1 className="text-5xl md:text-6xl font-bold text-[#123f1e] mt-4">
            Student Resources
          </h1>
        </header>

        {/* Student Life Image */}
        <div className="mb-16">
          <img
            src="/assets/images/gallery/thumbnail_IMG_3704.jpg"
            alt="Students engaged in learning"
            className="w-full max-w-5xl mx-auto h-80 object-cover rounded-3xl shadow-xl"
          />
        </div>

        {/* Learning Platforms */}
        <div className="mb-20">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#123f1e] mb-8 tracking-tight text-center">Learning Platforms</h2>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* ClassDojo Card */}
            <a
              href="https://www.classdojo.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all duration-200 shadow-lg hover:shadow-xl overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>

              <div className="flex flex-col items-center text-center">
                <div className="mb-6 transform group-hover:scale-105 transition-transform duration-200">
                  <img
                    src="https://teach.classdojo.com/static/classdojo-logo.svg"
                    alt="ClassDojo Logo"
                    className="h-20 w-auto"
                  />
                </div>
                <h3 className="text-2xl font-bold text-[#123f1e] mb-3 tracking-tight">ClassDojo</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Connect with teachers, track your child's progress, and celebrate learning moments together.
                </p>
                <div className="inline-flex items-center gap-2 text-[#123f1e] font-semibold group-hover:text-[#7d5800] transition-colors">
                  <span>Visit ClassDojo</span>
                  <ExternalLink className="w-4 h-4" />
                </div>
              </div>
            </a>

            {/* Google Classroom Card */}
            <a
              href="https://classroom.google.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all duration-200 shadow-lg hover:shadow-xl overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-green-600 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>

              <div className="flex flex-col items-center text-center">
                <div className="mb-6 transform group-hover:scale-105 transition-transform duration-200">
                  <img
                    src="https://www.gstatic.com/classroom/logo_square_48.svg"
                    alt="Google Classroom Logo"
                    className="h-20 w-20"
                  />
                </div>
                <h3 className="text-2xl font-bold text-[#123f1e] mb-3 tracking-tight">Google Classroom</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Access assignments, class materials, and communicate with teachers in one organized place.
                </p>
                <div className="inline-flex items-center gap-2 text-[#123f1e] font-semibold group-hover:text-[#7d5800] transition-colors">
                  <span>Visit Google Classroom</span>
                  <ExternalLink className="w-4 h-4" />
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* Uniforms Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#123f1e] mb-2 tracking-tight">School Uniforms</h2>
          <p className="text-xl text-gray-600">Optional</p>
        </div>

        {/* Uniform Information */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Info Cards */}
          <div className="space-y-6">
            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-pink-100 rounded-xl">
                  <ShirtIcon className="w-6 h-6 text-pink-600" />
                </div>
                <h3 className="text-2xl font-bold text-[#123f1e]">Girls</h3>
              </div>
              <ul className="space-y-2 text-gray-700">
                <li>• Yellow blouse and navy blue jumpers/pants</li>
                <li>• Polo (logo) shirt and navy skirt</li>
                <li>• Navy blue socks and velcro shoes</li>
              </ul>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-3 bg-blue-100 rounded-xl">
                  <ShirtIcon className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold text-[#123f1e]">Boys</h3>
              </div>
              <ul className="space-y-2 text-gray-700">
                <li>• Polo (logo) shirt and navy blue pants</li>
                <li>• Dark socks and velcro shoes</li>
              </ul>
            </div>

            <div className="bg-[#123f1e] rounded-2xl p-8 text-white">
              <p className="text-lg mb-4">
                <strong>Gym Uniform with logo may also be worn daily.</strong>
              </p>
              <a
                href="https://www.cookieskids.com/locations.aspx?srsltid=AU7gw4XzOpWstuwfgadMokbNgVAcuJrO1piPdBkIBcmPGiyYz9AW35EF"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#febc04] text-[#123f1e] font-bold rounded-xl hover:bg-[#e5a903] transition-all"
              >
                <span>Find Store Location</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Images */}
          <div className="grid grid-cols-2 gap-6">
            <img
              src="https://goldprekd9.com/wp-content/uploads/2023/10/uniform-1-rotated.jpg"
              alt="GoLD Pre-K student wearing the school polo shirt and navy pants"
              className="rounded-2xl shadow-xl"
            />
            <img
              src="https://goldprekd9.com/wp-content/uploads/2023/10/uniform-2-rotated.jpg"
              alt="GoLD Pre-K student wearing the school gym uniform"
              className="rounded-2xl shadow-xl"
            />
          </div>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Students;
